import { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";

import { dataActions } from "../store/data-slice";
import { screenActions } from "../store/screens-slice";

import ScrollMenu from "react-horizontal-scrolling-menu";
import "./Months.css";

import { useTranslation } from "react-i18next";

import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";

const detectMob = () => {
  var isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
  if (isMobile) {
    return true;
  } else {
    return false;
  }
};

const MenuItem = ({ text, selected }) => {
  return <div className={`menu-item ${selected ? "active" : ""}`}>{text}</div>;
};

export const Menu = (list, selected) =>
  list.map((item) => {
    return (
      <MenuItem
        text={item.month.name}
        key={item.month.name}
        selected={selected}
      />
    );
  });

const Arrow = ({ icon, className }) => {
  return (
    <div className={className}>
      {icon === "<" ? <ArrowBackIosIcon /> : <ArrowForwardIosIcon />}
    </div>
  );
};

const ArrowLeft = detectMob
  ? Arrow({ icon: "<", className: "arrow-prev" })
  : false;
const ArrowRight = detectMob
  ? Arrow({ icon: ">", className: "arrow-next" })
  : false;

const getData = (cursos, t) => {
  let months = [];
  for (const [key, value] of Object.entries(cursos)) {
    let year = parseInt(key.substring(2, 6));
    let month_num = parseInt(key.substring(0, 2));
    if (month_num == 1) {
      months.push({
        month: {
          id: 1,
          name: t("MONTHS.months_list.1"),
          year,
          value,
        },
      });
    } else if (month_num == 2) {
      months.push({
        month: {
          id: 2,
          name: t("MONTHS.months_list.2"),
          year,
          value,
        },
      });
    } else if (month_num == 3) {
      months.push({
        month: {
          id: 3,
          name: t("MONTHS.months_list.3"),
          year,
          value,
        },
      });
    } else if (month_num == 4) {
      months.push({
        month: {
          id: 4,
          name: t("MONTHS.months_list.4"),
          year,
          value,
        },
      });
    } else if (month_num == 5) {
      months.push({
        month: {
          id: 5,
          name: t("MONTHS.months_list.5"),
          year,
          value,
        },
      });
    } else if (month_num == 6) {
      months.push({
        month: {
          id: 6,
          name: t("MONTHS.months_list.6"),
          year,
          value,
        },
      });
    } else if (month_num == 7) {
      months.push({
        month: {
          id: 7,
          name: t("MONTHS.months_list.7"),
          year,
          value,
        },
      });
    } else if (month_num == 8) {
      months.push({
        month: {
          id: 8,
          name: t("MONTHS.months_list.8"),
          year,
          value,
        },
      });
    } else if (month_num == 9) {
      months.push({
        month: {
          id: 9,
          name: t("MONTHS.months_list.9"),
          year,
          value,
        },
      });
    } else if (month_num == 10) {
      months.push({
        month: {
          id: 10,
          name: t("MONTHS.months_list.10"),
          year,
          value,
        },
      });
    } else if (month_num == 11) {
      months.push({
        month: {
          id: 11,
          name: t("MONTHS.months_list.11"),
          year,
          value,
        },
      });
    } else if (month_num == 12) {
      months.push({
        month: {
          id: 12,
          name: t("MONTHS.months_list.12"),
          year,
          value,
        },
      });
    }
  }
  return months;
};

const Months = () => {
  const [serverDate, setServerDate] = useState();
  const [selected, setselected] = useState();
  const [menu, setmenu] = useState([]);
  const [calendarios, setCalendarios] = useState([]);
  const environment = process.env.REACT_APP_ENVIRONMENT;
  const [t, i18n] = useTranslation("global");
  const dispatch = useDispatch();

  useEffect(() => {
    fetchData();
    fetchDate();
  }, []);

  const fetchData = async () => {
    console.log("=== app running in " + environment + " mode ===");
    let domain =
      environment === "development"
        ? "http://localhost:7000"
        : "https://reservas.escolaportbarcelona.com/api";

    try {
      const dataPracticas = await fetch(`${domain}/get_salidas_club`, {
        headers: {
          "X-Requested-With": "XMLHttpRequest",
        },
      });
      let { status, statusText } = dataPracticas;

      if (status === 200) {
        const result_practicas = await dataPracticas.json();

        // getData - Devuelve meses traducidos
        let calendarios_data_practicas = getData(result_practicas, t);

        calendarios_data_practicas = calendarios_data_practicas.sort(
          (a, b) =>
            new Date(a.month.year, a.month.id, 1) -
            new Date(b.month.year, b.month.id, 1)
        );

        setmenu(Menu(calendarios_data_practicas, selected));
        setCalendarios(calendarios_data_practicas);

        dispatch(dataActions.applyDataPracticas(calendarios_data_practicas));

        calendarios_data_practicas.forEach((e) => {
          let month = calendarios_data_practicas[0].month.name;
          setselected(month);
        });
      } else {
        dispatch(screenActions.setMainScreen("errorscreen"));
      }
    } catch (e) {
      dispatch(screenActions.setMainScreen("errorscreen"));
    }
  };

  const fetchDate = async () => {
    let domain =
      environment === "development"
        ? "http://localhost:7000"
        : "https://reservas.escolaportbarcelona.com/api";

    const serverDate = await fetch(`${domain}/get_date`, {
      headers: {
        "X-Requested-With": "XMLHttpRequest",
      },
    });

    //Hora del servidor (fetch y enviar a Redux)
    const result_serverDate = await serverDate.json();
    setServerDate(result_serverDate);

    dispatch(dataActions.applyServerDate(result_serverDate));
  };

  const onSelect = (key) => {
    setselected(key);
    dispatch(screenActions.setMonthSelected(key));
    dispatch(screenActions.setScrollDivPracticas(""));
  };

  return (
    <div className="months__container">
      <ScrollMenu
        data={menu}
        arrowLeft={calendarios.length <= 2 ? false : ArrowLeft}
        arrowRight={calendarios.length <= 2 ? false : ArrowRight}
        selected={selected}
        onSelect={onSelect}
        translate={1}
      />
    </div>
  );
};

export default Months;
